import store from 'src/js/store';
import hideHighlighter from '../actions/hide';

function hide(elements) {
  store.dispatch(hideHighlighter(elements));
}

export default hide;
